export const REAL_INTERACTION_EVENT_TYPES = [
  "call_completed",
  "meeting_completed",
  "message_sent",
  "message_received",
  "lead_replied",
  "email_sent",
  "email_received",
  "whatsapp_sent",
  "whatsapp_received",
  "instagram_sent",
  "instagram_received",
] as const;

const realInteractionTypes = new Set<string>(REAL_INTERACTION_EVENT_TYPES);

export function countsAsInteraction(eventType: string) {
  return realInteractionTypes.has(eventType.trim().toLowerCase());
}

export function inactivityReference(lastInteractionAt: string | undefined, createdAt: string) {
  return {
    timestamp: lastInteractionAt ?? createdAt,
    hasInteraction: Boolean(lastInteractionAt),
  };
}
